import axios from 'axios'
import {
  CMS_URL,
  CMS_APP_NAME,
  CMS_CLIENT_ID,
  CMS_CLIENT_SECRET
} from '../configs/constants'

const getLocalToken = () => window.localStorage.getItem('CMS_TOKEN')
const setLocalToken = (token) => window.localStorage.setItem('CMS_TOKEN', token)
const clearLocalToken = () => window.localStorage.clear()

const retrieveNewCMSToken = async () => {
  try {
    const response = await axios({
      method: 'POST',
      url: `${CMS_URL}/identity-server/connect/token`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: `grant_type=client_credentials&scope=squidex-api&client_id=${CMS_CLIENT_ID}&client_secret=${CMS_CLIENT_SECRET}`
    })

    const data = response.data
    const token = data.access_token
    clearLocalToken()
    setLocalToken(token)
    return token
  } catch (err) {
    console.error('ERR WHILE RETRIEVING CMS TOKEN: ', err)
    return null
  }
}

const getCMSContent = async (query) => {
  let accessToken = getLocalToken()
  if (!accessToken) {
    accessToken = await retrieveNewCMSToken()
  }

  try {
    const response = await axios({
      method: 'POST',
      url: `${CMS_URL}/api/content/${CMS_APP_NAME}/graphql`,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`
      },
      data: {
        query
      }
    })

    const contents = response.data.data
    return contents
  } catch (err) {
    console.error('ERR WHILE RETRIEVING HOME CMS CONTENT: ', err)
    if (err.status === 403 || err.status === 401) {
      clearLocalToken()
      getCMSContent()
    }
    return null
  }
}

export { getCMSContent }
